import { useMemo } from 'react';
import { useTypedQuery } from 'apiTyped/helpers/useTypedQuery';

export interface MediaReportingFilters {
  client?: string | null;
  opponents?: string[];
  fromDate?: string | null;
  toDate?: string | null;
}

export const useMediaReporting = (filters: MediaReportingFilters = {}) => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/v2/media/reporting',
    {
      params: {
        query: {
          _client: filters.client ?? undefined,
          _opponents: filters.opponents?.join(',') || undefined,
          _from_date: filters.fromDate ?? undefined,
          _to_date: filters.toDate ?? undefined
        }
      },
      queryOpts: {
        enabled: !!filters.client
      }
    }
  );

  const mapped = useMemo(() => {
    if (!data) return null;
    const d = data as any;
    return {
      extractionPrevious: d.extraction_previous || [],
      extractionCurrent: d.extraction_current || [],
      sourceTypePrevious: d.source_type_previous || [],
      sourceTypeCurrent: d.source_type_current || [],
      timeseries: (d.timeseries || []).map((t: any) => ({
        date: t.date,
        ...t.values
      })),
      competitorComparison: (d.competitor_comparison || []).map((c: any) => ({
        name: c.name,
        Articles: c.articles,
        Sources: c.sources
      })),
      yoyArticles: (d.yoy_articles || []).map((y: any) => ({
        client: y.client,
        [String(new Date().getFullYear() - 1)]: y.previous_year,
        [String(new Date().getFullYear())]: y.current_year
      })),
      yoySources: (d.yoy_sources || []).map((y: any) => ({
        client: y.client,
        [String(new Date().getFullYear() - 1)]: y.previous_year,
        [String(new Date().getFullYear())]: y.current_year
      })),
      yoyGrowth: (d.yoy_growth || []).map((g: any) => ({
        label: g.label,
        articleGrowth: g.article_growth,
        sourceGrowth: g.source_growth
      })),
      countryDistribution: (d.country_distribution || []).map((c: any) => ({
        country: c.country,
        'Client Articles': c.client_articles,
        'Concurrent Moyenne': c.competitor_average
      })),
      opponents: d.opponents || []
    };
  }, [data]);

  return {
    isLoading,
    extractionPrevious: mapped?.extractionPrevious ?? [],
    extractionCurrent: mapped?.extractionCurrent ?? [],
    sourceTypePrevious: mapped?.sourceTypePrevious ?? [],
    sourceTypeCurrent: mapped?.sourceTypeCurrent ?? [],
    timeseries: mapped?.timeseries ?? [],
    competitorComparison: mapped?.competitorComparison ?? [],
    yoyArticles: mapped?.yoyArticles ?? [],
    yoySources: mapped?.yoySources ?? [],
    yoyGrowth: mapped?.yoyGrowth ?? [],
    countryDistribution: mapped?.countryDistribution ?? [],
    opponents: mapped?.opponents ?? [],
    refetch
  };
};
